import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

const SearchOnSiteDeliveries = ({ onSearch }) => {
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            onSearch(searchTerm);
        }, 500);

        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm, onSearch]);

    const handleChange = (event) => {
        setSearchTerm(event.target.value);
    };

    return (
        <TextField
            fullWidth
            variant="outlined"
            placeholder="Buscar por orden, cliente, documento..."
            value={searchTerm}
            onChange={handleChange}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon />
                    </InputAdornment>
                ),
            }}
            sx={{ marginBottom: 2, backgroundColor: "white" }}
        />
    );
};

export default SearchOnSiteDeliveries;
